<template>
  <div class="boxbgcolor">
    <div class="left content-left">
      <shareParkingTree v-on:handleTreeClick="handleTreeClick" shareType="share" moduleName="parking"></shareParkingTree>
    </div>
    <div class="right content-right list">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <!-- <div class="form-group">
            <label for="a_name">车场：</label>
            <el-select
              v-model="search.parkingId"
              @change="onParkChange"
              clearable
            >
              <el-option
                v-for="item in parks"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="form-group">
            <label for="a_name">区域：</label>
            <el-select v-model="search.areaId" clearable>
              <el-option
                v-for="item in areas"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="tableLoading"
              >
                查询
              </el-button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="add"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-if="search.parkingId"
          v-loading="tableLoading"
        >
          <el-table-column
            show-overflow-tooltip
            label="规则名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="停车场"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="区域"
            prop="areaName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="收费模式"
            prop="chargeMode"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车辆类型"
            prop="carType"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌类型"
            prop="plateType"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="收费限额"
            prop="quota"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="限额类型"
            prop="quotaType"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="循环计费包含"
            prop="circularBillingType"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="计费类型"
            prop="chargeType"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="免费时长"
            prop="freeTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="延续类型"
            prop="continueType"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="edit operate-button"
                type="button"
                @click="test(scope.row)"
              >
                测试
              </button>
              <button
                class="edit operate-button"
                type="button"
                @click="edit(scope.row)"
              >
                修改
              </button>

              <button
                class="delete operate-button"
                @click="del(scope.row.id)"
                type="button"
              >
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-else
          style="height: 100%; display: flex; justify-content: center; align-items: center;"
        >
          <el-empty description="请先选择左侧的停车场"></el-empty>
        </div>
      </div>
    </div>

    <Page v-on:pagination="receivePaginationData"></Page>
    <el-dialog title="收费规则测试" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="时间" :label-width="formLabelWidth">
          <el-date-picker
            clearable
            v-model="testForm.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
          <span style="display: inline-block;width:50px;"></span>
          <el-button
            :loading="testLoading"
            @click="onTestSureBtn"
            :disabled="testForm.time.length <= 0"
            style=""
            >确定</el-button
          >
        </el-form-item>
        <el-form-item label="测试结果:" :label-width="formLabelWidth">
          <el-input
            style="width:59%;background:#eee"
            readonly
            v-model="testResult"
          ></el-input
          >元
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import dayjs from "dayjs";
import {
  shareChargeRuleList,
  delShareSpaceChargeRule,
  shareParks,
  areasByShareParkingId,
  testChargeRule,
} from "@/api/url";

import Page from "@/page/commons/page.vue";
// import AreaTree from "@/page/commons/parking/commons/areaTree.vue";
import shareParkingTree from "../../../commons/parking/commons/share-parking-tree.vue";
import {
  CHARGE_MODE,
  CAR_TYPE,
  PLATE_TYPE,
  QUOTA_TYPE,
  CIRCULAR_BILLING_TYPE,
  CHARGE_TYPE,
  CONTINUE_TYPE,
} from "./constant";
export default {
  data() {
    return {
      tableLoading: false,
      testLoading: false,
      parks: [],
      areas: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        parkingId: "",
        areaId: "",
      },

      tableListData: {
        rows: [],
      },

      formLabelWidth: "100px",
      testResult: "",
      testForm: {
        time: [],
      },
      currentRule: {},
    };
  },

  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    add() {
      this.$router.push({
        path: "/main/park/parking-charge-rule/update",
      });
    },
    edit(row) {
      this.$router.push({
        path: "/main/park/parking-charge-rule/update",
        query: {
          id: row.id,
        },
      });
    },
    tableList: function(curPage) {
      var _this = this;
      this.tableLoading = true;
      const param = {};
      if (this.search.parkingId) param.parkingId = this.search.parkingId;
      if (this.search.areaId) param.areaId = this.search.areaId;
      this.$get(shareChargeRuleList(), {
        limit: this.search.pageSize,
        page: curPage,
        ...param,
      })
        .then((data) => {
          if (data.status != 200) return _this.$message.error(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);

          const {
            data: { rows },
          } = data;
          _this.tableListData.rows = rows.map((item) => {
            console.log("CHARGE_MODE=>", CHARGE_MODE);
            item.chargeMode = CHARGE_MODE[item.chargeMode];
            item.carType = CAR_TYPE[item.carType];
            item.plateType = PLATE_TYPE[item.plateType];
            item.quotaType = QUOTA_TYPE[item.quotaType];
            item.circularBillingType =
              CIRCULAR_BILLING_TYPE[item.circularBillingType];
            item.chargeType = CHARGE_TYPE[item.chargeType];
            item.continueType = CONTINUE_TYPE[item.continueType];
            return item;
          });
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    searchList: function() {
      if (!this.search.parkingId)
        return this.$message({ type: "error", message: "请先选择停车场" });
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    del: function(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function() {
          _this.$layer.close(index);

          _this
            .$deleteRequest(delShareSpaceChargeRule() + "/" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$message.error("删除失败", { time: 1 });
              _this.tableList(_this.search.pageNumber);
            });
        }
      );
    },
    test(row) {
      this.currentRule = { ...row };
      this.dialogFormVisible = true;
    },
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((res) => {
        if (res.status == 200) {
          this.parks = res.data.data.rows ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onParkChange(id) {
      this.search.areaId = "";
      this.$get(`${areasByShareParkingId()}/${id}`, {}).then((res) => {
        if (res.status == 200) {
          this.areas = res.data ?? [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onTestSureBtn() {
      this.testLoading = true;
      this.$get(testChargeRule(), {
        id: this.currentRule.id,
        startTime: dayjs(this.testForm.time[0]).format("YYYY-MM-DD HH:mm:ss"),
        endTime: dayjs(this.testForm.time[1]).format("YYYY-MM-DD HH:mm:ss"),
      })
        .then((res) => {
          if (res?.status != 200) return this.$message.error(res.message);
          this.testResult = res.data?.resultMoney ?? "";
        })
        .finally((res) => {
          this.testLoading = false;
        });
    },
    handleTreeClick: function(node) {
      // 如果节点类型为停车场
      if (node.type === "parking") {
        this.search.parkingId = node.id;
        this.onParkChange(node.id);
        // 获取数据
        this.tableList(this.search.pageNumber);
      } else this.search.parkingId = undefined;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
shareParkingTree
  },

  created: function() {},
  mounted: function() {
    this.search.pageNumber = 1;
    // this.tableList(1);
    // this.getShareParks();
  },
};
</script>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
